import {Alert, AlertTitle, Grid, Typography} from "@mui/material";
import {ActivityStatusStory} from "../../../../types/activity/activityData";
import Skeleton from '@material-ui/lab/Skeleton';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import SolicitationTaskStatusTimelineItem from "./SolicitationTaskStatusTimelineItem";
import {TimelineOppositeContent} from "@mui/lab";


interface SolicitationTaskTimelineDetailProps {
    lstStatus: ActivityStatusStory[],
    loading: boolean,
    taskId: number
}


const SolicitationTaskTimelineDetail = ({lstStatus, loading, taskId}: SolicitationTaskTimelineDetailProps) => {
    
    return (
        <Typography component="div">
            {
                loading ?
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Skeleton variant="rect" animation="wave" />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton variant="rect" animation="wave" />
                        </Grid>
                    </Grid>
                    :
                    lstStatus.length === 0 ?
                        <Alert severity="info">
                            <AlertTitle>No hay registros!</AlertTitle>
                            Al parecer no encontramos estados para esta actividad.
                        </Alert>
                        :
                        <Timeline>
                            {
                                lstStatus.map((activityStatusStory, index) => (
                                    <TimelineItem key={`timeline_${index}_${taskId}`}>
                                        <SolicitationTaskStatusTimelineItem entity={activityStatusStory} />
                                        <TimelineOppositeContent style={{display: 'none'}}/>
                                    </TimelineItem>
                                ))
                            }
                        </Timeline>
            }
        </Typography>
    )
}


export default SolicitationTaskTimelineDetail